module.exports = __webpack_public_path__ + "img/title.ca5eb9db.svg";